import classNames from 'classnames';
import type { components } from 'react-select';

import styles from './IndicatorsContainer.module.scss';

export const IndicatorsContainer: typeof components.IndicatorsContainer = ({ selectProps }) => {
    // @ts-expect-error
    const { colorTheme, view } = selectProps;

    return (
        <div
            className={classNames('indicatorsContainer', styles.indicatorsContainer, {
                [styles.dark]: colorTheme === 'dark',
                [styles.compact]: view === 'compact',
            })}
        >
            <span className={styles.text}>Press to search</span>
            <span className={styles.hotKey}>/</span>
        </div>
    );
};
